<template>
  <div>
    <div>
      <h5>Role: Super Admin</h5>
      <b-form-checkbox
        v-model="selectAll"
        class="mt-2"
        @click="selectAllPages"
      >
        Select All
      </b-form-checkbox>
    </div>
    <b-row class="mt-2">
      <b-col
        v-for="moduleItem in modules"
        :key="moduleItem.pageTitle"
        md="4"
      >
        <b-card
          no-body
          class="business-card"
        >
          <b-card-header

            class="pb-1"
          >
            <b-card-title>{{ moduleItem.pageTitle }}</b-card-title>
          </b-card-header>

          <b-card-body>
            <div class="business-items">
              <div class="d-flex align-items-center justify-content-between business-item mt-1">
                <b-form-checkbox :checked="moduleItem.label.checked">
                  {{ moduleItem.label.item }}
                </b-form-checkbox>
              </div>

              <div
                v-for="page in moduleItem.pages"
                :key="page.pageName"
                class="business-item"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <b-form-checkbox :checked="page.checked">
                    {{ page.pageName }}
                  </b-form-checkbox>
                </div>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <!-- button -->
    <div class="text-center">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        size="lg"
      >
        Save
      </b-button>
    </div>

  </div>

</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody, BFormCheckbox, BRow, BCol, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BCard,
    BButton,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      selectAll: false,
      pagesSelect: [],
      modules: [
        {
          pageTitle: 'Accounts',
          label: { item: 'Select All', checked: false },
          pages: [
            {
              id: 1,
              pageName: 'Account Category',
              checked: false,
            },
            {
              id: 2,
              pageName: 'Account Officer',
              checked: true,
            },
            {
              id: 3,
              pageName: 'Charges',
              checked: false,
            },
            {
              id: 4,
              pageName: 'Customer Account',
              checked: false,
            },
            {
              id: 5,
              pageName: 'Customer Information',
              checked: true,
            },

          ],
        },
        {
          pageTitle: 'Admin Portal',
          label: { item: 'Select All', checked: false },
          pages: [
            {
              id: 1,
              pageName: 'Billings',
              checked: true,
            },
            {
              id: 2,
              pageName: 'Institutions',
              checked: false,
            },
            {
              id: 3,
              pageName: 'User Management',
              checked: false,
            },
            {
              id: 4,
              pageName: 'User Roles',
              checked: true,
            },
          ],
        },
        {
          pageTitle: 'Channels',
          label: { item: 'Select All', checked: false },
          pages: [
            {
              id: 1,
              pageName: 'List',
              checked: false,
            },
            {
              id: 2,
              pageName: 'Preview',
              checked: true,
            },

          ],
        },
        {
          pageTitle: 'Communications',
          label: { item: 'Select All', checked: false },
          pages: [
            {
              id: 1,
              pageName: 'Account Category',
              checked: false,
            },
            {
              id: 2,
              pageName: 'Account Officer',
              checked: true,
            },
            {
              id: 3,
              pageName: 'Charges',
              checked: false,
            },
            {
              id: 4,
              pageName: 'Customer Account',
              checked: true,
            },
            {
              id: 5,
              pageName: 'Customer Information',
              checked: false,
            },

          ],
        },
        {
          pageTitle: 'Operations',
          label: { item: 'Select All', checked: false },
          pages: [
            {
              id: 1,
              pageName: 'Approvals',
              checked: false,
            },
            {
              id: 2,
              pageName: 'Audit Trail',
              checked: true,
            },
            {
              id: 3,
              pageName: 'Business Automation',
              checked: true,
            },
            {
              id: 4,
              pageName: 'Business',
              checked: true,
            },
            {
              id: 5,
              pageName: 'Branch',
              checked: true,
            },
            {
              id: 6,
              pageName: 'Configurations and Settings',
              checked: false,
            },
            {
              id: 7,
              pageName: 'Country',
              checked: false,
            },
            {
              id: 8,
              pageName: 'Region',
              checked: true,
            },

          ],
        },
        {
          pageTitle: 'Posting & EOD',
          label: { item: 'Select All', checked: false },
          pages: [
            {
              id: 1,
              pageName: 'Postings',
              checked: false,
            },
          ],
        },
        {
          pageTitle: 'Utilities',
          label: { item: 'Select All', checked: false },
          pages: [
            {
              id: 1,
              pageName: 'API Gateway',
              checked: false,
            },
          ],
        },
        {
          pageTitle: 'Reports',
          label: { item: 'Select All', checked: false },
          pages: [
            {
              id: 1,
              pageName: 'Financial Reports',
              checked: true,
            },
            {
              id: 2,
              pageName: 'Operational Reports',
              checked: true,
            },
            {
              id: 3,
              pageName: 'Regulatory Reports',
              checked: true,
            },
          ],
        },

      ],
    }
  },
  methods: {
    selectAllPages() {
      if (this.selectAll) {
        // for (module in this.modules) {
        //   this.pagesSelect.push({ moduleName: module.pageName, id: module.id })
        // }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.business-card .business-items .business-item {
    border: none;
}
.business-card {
  min-height: 45.313rem;
}
</style>
